import React from "react";
import "../BudgetReportDashboard.css";
import { Bar } from "react-chartjs-2";
export const BudgetReportChartMain = (props) => {
  const categoryNames = props.data ? props.data.map(item => item.categoryName) : [];
  const totalTransactions =props.data ? props.data.map(item => item.totalTransactions) :[];
  const data = {
    labels: categoryNames ,
    datasets: [
      {
        label: "Category",
        data: totalTransactions,
        fill: false,
        backgroundColor: "#2A3DA3",
        borderColor: "#2A3DA3",
      },
    ],
  };
  const chartOptions = {
    legend: {
      display: false,
    },

    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(value);
            },
          },
        },
      ],
    },
  };
  return (
    <React.Fragment>
      <div className="reportInfoMaincard">
        <h3 className="reportCardheading">All Budgets</h3>
        <div style={{ marginTop: "1rem" }}>
          {" "}
          <Bar
            data={data}
            height={300}
            options={chartOptions}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
